import { create } from 'zustand';
import { QRStore } from '../types';

export const useQRStore = create<QRStore>((set) => ({
  dataFromURL: null,
  setDataFromURL: (dataFromURL) => set({ dataFromURL }),
  mobileNumber: '',
  setMobileNumber: (mobileNumber) => set({ mobileNumber }),
  codeToVerify: '',
  setCodeToVerify: (codeToVerify) => set({ codeToVerify }),
  userDetail: null,
  setUserDetail: (userDetail) => set({ userDetail }),
  isDirty: false,
  setIsDirty: (isDirty) => set({ isDirty }),
}));
